var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"linkedin"),React.createElement("path",{"d":"M7.07,6.2Z","transform":"translate(-3.37 -3.53)","key":1}),React.createElement("path",{"d":"M4.87,9.8H3.47V5.57h1.4ZM4.17,5h0a.75.75,0,0,1-.8-.73.74.74,0,0,1,.8-.74.76.76,0,0,1,.8.74A.73.73,0,0,1,4.17,5ZM9.93,9.8H8.53V7.53c0-.56-.2-1-.7-1a.77.77,0,0,0-.73.5,1.12,1.12,0,0,0,0,.33V9.77H5.67s0-3.84,0-4.24h1.4v.6a1.4,1.4,0,0,1,1.26-.7c.94,0,1.6.6,1.6,1.9Z","transform":"translate(-3.37 -3.53)","key":2})]);
}

Linkedin.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 6.57 6.27"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
